import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import ToastProvider from './components/ToastProvider/ToastProvider';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<ErrorBoundary>
			<BrowserRouter>
				<ToastProvider>
					<App />
				</ToastProvider>
			</BrowserRouter>
		</ErrorBoundary>
	</React.StrictMode>,
);
